module.exports = __webpack_public_path__ + "img/BIT_white06.75b90596.jpg";